import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Button } from '@ipc/ipc-components';
import ListTable from '../../../common/tables/ListTable';
import TableDefinitions from '../../../common/TableDefinitions';
import {
  getColumns,
  getData,
  getIsLoading,
  getCheckedRows,
} from '../redux/selectors/RfidUploadedFilesListSelectors';
import { tableLoadData } from '../../../common/tables/actions/ListTableActions';
import RfidFilesErrorsContainer from '../errors/containers/RfidFilesErrorsContainer';
import RfidFileDelete from '../delete/containers/RfidFileDelete';
import RfidFileUploadDialog from '../upload/containers/RfidFileUploadDialog';
import RfidFileTemplate from '../../../../downloadables/RFID_FILE_template.csv';
import { RfidUploadedFilesListContainerStyle } from './RfidUploadedFilesListContainer.styles';
import { downloadRfidFileRequestActionCreator } from '../download/redux/actions/RfidFileDownloadActions';

class RfidUploadedFilesListContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showDeleteModal: false,
      showUploadModal: false,
    };
    this.deleteRfidFile = this.deleteRfidFile.bind(this);
    this.showUploadModal = this.showUploadModal.bind(this);
    this.hideUploadModal = this.hideUploadModal.bind(this);
    this.downloadFiles = this.downloadFiles.bind(this);
  }

  showDeleteFormModal = () => {
    this.setState({
      showDeleteModal: true,
    });
  }

  hideDeleteFormModal = () => {
    this.setState({
      showDeleteModal: false,
    });
  }

  deleteRfidFile() {
    this.setState({
      showDeleteModal: true,
    });
  }

  showUploadModal() {
    this.setState({
      showUploadModal: true,
    });
  }

  hideUploadModal() {
    this.setState({
      showUploadModal: false,
    });
  }

  downloadFiles() {
    this.props.downloadRfidFileRequestActionCreator();
  }

  render() {
    return (
      <div className="general-content-container">
        <RfidUploadedFilesListContainerStyle>
          <h1 className="title-div">RFID FILE MANAGEMENT</h1>
          <div className="button-group">
            <Button
              className={`action-buttons primary-button-${!(this.props.checkedRows !== undefined && this.props.checkedRows.length !== 0)}`}
              disabled={!(this.props.checkedRows !== undefined && this.props.checkedRows.length !== 0)}
              onClick={this.deleteRfidFile}
            >
              DELETE
            </Button>
            <a href={RfidFileTemplate} download="RFID_FILE_template.csv">
              <Button className="action-buttons">
                Download CSV Template
              </Button>
            </a>
            <Button
              className={`action-buttons primary-button-${!(this.props.checkedRows !== undefined && this.props.checkedRows.length !== 0)}`}
              disabled={!(this.props.checkedRows !== undefined && this.props.checkedRows.length !== 0)}
              onClick={this.downloadFiles}
            >
              DOWNLOAD RFID FILE
            </Button>
            <Button className="action-buttons" onClick={this.showUploadModal}>
              Upload RFID File
            </Button>
          </div>
          <ListTable
            listId={TableDefinitions.RFID_UPLOADED_FILES_LIST.id}
            loading={this.props.isLoading}
            columns={this.props.columns}
            data={this.props.data}
            keyField="id"
            selectCheckbox
            pagination
            getSubComponentProps={(row) => (
              <div style={{ padding: '20px' }}>
                <RfidFilesErrorsContainer
                  row={row}
                />
              </div>
            )}
          />
          {this.state.showDeleteModal && (
            <RfidFileDelete
              row={this.props.checkedRows}
              closeDialog={this.hideDeleteFormModal}
              openDialog={this.showDeleteFormModal}
            />
          )}
          <RfidFileUploadDialog
            open={this.state.showUploadModal}
            hideModal={this.hideUploadModal}
          />
        </RfidUploadedFilesListContainerStyle>
      </div>
    );
  }
}

RfidUploadedFilesListContainer.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  columns: PropTypes.arrayOf(PropTypes.object),
  isLoading: PropTypes.bool,
  downloadRfidFileRequestActionCreator: PropTypes.func.isRequired,
  checkedRows: PropTypes.arrayOf(PropTypes.object),
};

RfidUploadedFilesListContainer.defaultProps = {
  checkedRows: [],
};

function mapStateToProps(state) {
  return {
    data: getData(state),
    columns: getColumns(state),
    isLoading: getIsLoading(state),
    checkedRows: getCheckedRows(state),
  };
}

const mapDispatchToProps = (dispatch) => bindActionCreators({
  tableLoadData,
  downloadRfidFileRequestActionCreator,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(RfidUploadedFilesListContainer);
